module.exports = __webpack_public_path__ + "static/media/localParaEventosEApresentacoes.db9ff0a8.svg";